import { Component } from '@angular/core';
import { User } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/viewbid/state/app-state';
import { Store } from '@ngrx/store';
import { selectUser } from '../../../../state/app-selectors';
import { Router } from '@angular/router';
import { ProfileService } from 'src/app/viewbid/shared/services/profile.service';
import { SocketService } from 'src/app/viewbid/shared/services/socket.service';

@Component({
    selector: 'app-registration-confirmation-page',
    templateUrl: './registration-confirmation-page.component.html',
    styleUrls: ['./registration-confirmation-page.component.scss'],
})
export class RegistrationConfirmationPageComponent {
    public user$: Observable<User | null>;
    public user: User | null = null;
    isCardAdded: boolean = false;
    isPhoneVerified: boolean = false;
    isPhoneVerificationSkipped: boolean = false;

    constructor(
        private store: Store<AppState>,
        private router: Router,
        private profileService: ProfileService,
        private socketService: SocketService,
    ) {
        this.profileService.updateUserStore();
        this.user$ = this.store.select<User | null>(selectUser);
        this.user$.subscribe((user: User | null) => {
            this.user = user;
            this.socketService.initialize();
        });
    }

    goToAllAuctions(): void {
        this.profileService.subscribeToUserChanges();
        this.router.navigate(['/auctions'], {
            replaceUrl: true,
        });
    }

    goToUserProfile(): void {
        this.profileService.subscribeToUserChanges();
        this.router.navigate(['/profiles/my-profile/profile'], {
            replaceUrl: true,
        });
    }

    isPhoneNumberVerified(isVerified: boolean): void {
        this.isPhoneVerified = isVerified;
    }

    skipTelephoneVerification(): void {
        this.isPhoneVerificationSkipped = true;
    }
}
